'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.controller("CompteEditionPopinController", function ($scope, $http, $q, currencyService, lovService, $authz, stringUtils) {
  var isEdit = $scope.edit;
  $scope.admin = $authz.hasRole("IT_ADMINISTRATION");
  $scope.experimentateur = $authz.hasRole("EXPERIMENTATEUR");
  $scope.clientSelectConfig = {
    idAttribute: "id",
    options: "clients",
    optionTemplate: '' + '<div class="report-template-option">' + '   <span class="label">{{option.codePostal}} - {{option.nom}}</span>' + '</div>',
    matcher: function matcher(text, option) {
      // TODO : test the method
      return stringUtils.containsIgnoringCaseAndAccents(option.nom, text) || stringUtils.containsIgnoringCaseAndAccents(option.codePostal, text);
    }
  };
  $scope.compteParentSelectConfig = {
    idAttribute: "id",
    // inutile car is sur la directive coté html
    //options : "comptes",
    optionTemplate: '' + '<div class="report-template-option">' + '   <span class="label">{{option.nomInterne}}</span>' + '</div>',
    matcher: function matcher(text, option) {
      return stringUtils.containsIgnoringCaseAndAccents(option.nomInterne, text);
    }
  };
  console.log("CompteEditionPopinController scopz", $scope);
  $scope.uploadIconOptions = {
    url: '/rest/intra/comptes/uploadIcon'
  };
  $scope.removeCompteParent = function () {
    $scope.compte.compteParentId = null;
    $scope.compte.compteParentNomInterne = null;
    $scope.compte.CompteParent = null;
  };
  if ($scope.compteId) {
    $http.get("/rest/intra/comptes/get/" + $scope.compteId).then(function (response) {
      $scope.compte = response.data;
    });
  } else {
    $scope.compte = {
      'devise': 'EUR',
      locale: 'fr',
      pays: 'FRA'
    }; // PGA : need to fetch defaults maybe ?

    if ($scope.compteParentId != null) {
      $scope.compte.compteParentNomInterne = $scope.compteParentNomInterne;
      $scope.compte.compteParentId = $scope.compteParentId;

      // champs dispo sur intra.comptes.dto.CompteDTO (listing des comtpes)
      $scope.compte.clientId = $scope.compteParent.clientId;
      $scope.compte.affectation = $scope.compteParent.affectation;
      $scope.compte.consultantId = $scope.compteParent.consultantId;
      $scope.compte.consultant2Id = $scope.compteParent.consultant2Id;
    }
  }
  $scope.$watch("compte.datasId", function () {
    if ($scope.compte && $scope.compte.datasId != null) {
      $http.get("/rest/data/" + $scope.compte.datasId).then(function (response) {
        $scope.nomData = response.data.label;
      });
    } else {
      $scope.nomData = null;
    }
  });
  $q.when(lovService.getPays()).then(function (lov) {
    $scope.pays = lov;
  });
  $http.get("/rest/intra/comptes/all").then(function (response) {
    $scope.comptes = response.data;
  });
  $http.get("/rest/crmClient/clients").then(function (response) {
    $scope.clients = response.data;
  });

  // var originalCompteCommune = isEdit ? $scope.compte : {};
  // $scope.compte = angular.copy(originalCompteCommune);

  //// lovs -> cleanup.
  $scope.currencies = currencyService.getAll();
  $q.when(lovService.getTypesCompte()).then(function (lov) {
    $scope.typesCompte = lov;
  });
  $q.when(lovService.getLocales()).then(function (lov) {
    $scope.locales = lov;
  });
  $q.when(lovService.getAffectations()).then(function (lov) {
    $scope.affectations = lov;
  });
  $q.when(lovService.getApplicationsClients()).then(function (lov) {
    $scope.applicationsClients = lov;
  });
  $http.get('/rest/intra/utilisateurs/consultants').then(function (response) {
    $scope.consultants = _.sortBy(response.data, function (consultant) {
      return consultant.label;
    });
  });
  ////

  $scope.$watch('compte', function (newValue) {
    if (newValue != null && newValue.datasId == null) {
      if (newValue.nomDonneeAssociee == null || newValue.nomDonneeAssociee.length === 0) {
        if (newValue.nomClient != null && newValue.nomClient.length > 1 && newValue.zone != null && newValue.zone.length > 1) {
          var url = '/rest/data/compteCommune'; // TODO : rename
          if (newValue.typeCompte === 'EPCI' || newValue.typeCompte === 'METROPOLE_ET_COLLECTIVITE_TERRITORIALE') {
            url = '/rest/data/compteEPCI';
          }
          if (newValue.typeCompte === 'DEPARTEMENT') {
            url = '/rest/data/compteDepartement';
          }
          if (newValue.typeCompte === 'SDIS') {
            url = '/rest/data/compteSdis';
          }
          $http.get(url, {
            params: {
              nom: newValue.nomClient,
              zone: newValue.zone
            }
          }).then(function (response) {
            if (newValue.typeCompte === 'DEPARTEMENT') {
              $scope.datas = [];
              $scope.datas.push(response.data);
            } else {
              $scope.datas = response.data;
            }
          });
        } else {
          $scope.datas = null;
        }
      } else {
        if (newValue.nomDonneeAssociee.length > 1 && newValue.zone != null && newValue.zone.length > 1) {
          var url = '/rest/data/compteCommune'; // TODO : rename
          if (newValue.typeCompte === 'EPCI' || newValue.typeCompte === 'METROPOLE_ET_COLLECTIVITE_TERRITORIALE') {
            url = '/rest/data/compteEPCI';
          }
          if (newValue.typeCompte === 'DEPARTEMENT') {
            url = '/rest/data/compteDepartement';
          }
          if (newValue.typeCompte === 'SDIS') {
            url = '/rest/data/compteSDIS';
          }
          $http.get(url, {
            params: {
              nom: newValue.nomDonneeAssociee,
              zone: newValue.zone
            }
          }).then(function (response) {
            if (newValue.typeCompte === 'DEPARTEMENT' || newValue.typeCompte === 'SDIS') {
              $scope.datas = [];
              $scope.datas.push(response.data);
            } else {
              $scope.datas = response.data;
            }
          });
        } else {
          $scope.datas = null;
        }
      }
    }
  }, true);
  $scope.compteFormConfig = {
    url: function url() {
      return '/rest/intra/comptes/save';
    },
    data: function data() {
      return $scope.compte;
    },
    fieldPrefix: "compte.",
    fields: {
      nomInterne: {
        mandatory: true
      },
      nomClient: {
        mandatory: true
      },
      nomClientCourt: {
        mandatory: true
      },
      zone: {
        mandatory: true
      }
    },
    onSuccess: function onSuccess(savedCompte) {
      $scope.$close(savedCompte);
    },
    customValidation: function customValidation() {
      var errors = [];
      if ($scope.compte && $scope.compte.typeCompte === 'ENTREPRISE' && $scope.compte.compteParentId != null) {
        if ($scope.compte.participation == null) {
          errors.push({
            fieldName: 'participation',
            message: 'La participation (en %) doit être renseignée.'
          });
        }
      }
      return errors;
    }
  };
  $scope.onSmallIconUpload = function (result) {
    $scope.compte.smallIconFileId = result.fileId;
  };
  $scope.onBigIconUpload = function (result) {
    $scope.compte.bigIconFileId = result.fileId;
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/edition/compteEditionPopin.js
// module id = 2780
// module chunks = 13